export const common = {
  // Navbar
  "nav.home": "االرئسي",
  "nav.about": "من نحن",
  "nav.services": "خدماتنا",
  "nav.portfolio": "المحفظة",
  "nav.contact": "اتصل بنا",
  "nav.startInvesting": "ابدأ الاستثمار",

  // Hero
  "hero.badge": "تأسست 2019",
  "hero.title1": "نبني",
  "hero.title2": "إرث",
  "hero.title3": "الغد",
  "hero.subtitle": "التميز في الاستثمار",
  "hero.description": "من الامارات الى العالم نستثمر برؤية طويلة الامد في القطاعات الواعدة ونبني اعمالا مستدامة ترتكز عالى الابتكار و الحوكمة و التميز.",
  "hero.discoverMore": "اكتشف المزيد",
  "hero.getInTouch": "تواصل معنا",
  "hero.portfolioCompanies": "شركات المحفظة",
  "hero.headquarters": "المقر الرئيسي",
  "hero.established": "تأسست",
  "hero.strategicGrowth": "النمو الاستراتيجي",
  "hero.valueCreation": "خلق قيمة طويلة الأمد",
  "hero.scroll": "مرر للأسفل",

  // About
  "about.label": "من نحن",
  "about.title1": "الاستثمار الاستراتيجي",
  "about.title2": "المتميز",
  "about.description": "الأبل للاستثمار تركز على بناء قيمة طويلة الأمد من خلال الاستثمارات الاستراتيجية والملكية الفعالة والتميز التشغيلي عبر قطاعات متنوعة. تدعم الشركة الأعمال القابلة للتوسع والمشاريع المدفوعة بالابتكار في قطاعات الطاقة والتكنولوجيا والإلكترونيات والبنية التحتية والحلول الصناعية.",  
  "about.parentEntity": "الكيان الأم",
  "about.parentEntityDesc": "نعمل ككيان أم، نوفر رأس المال والحوكمة والإشراف الاستراتيجي للشركات التابعة والشريكة.",
  "about.uaeBased": "مقرها الإمارات",
  "about.uaeBasedDesc": "مقرها الرئيسي في الإمارات العربية المتحدة، تركز على الأسواق الإقليمية والدولية باستثمارات استراتيجية.",
  "about.activeOwnership": "الملكية الفاعلة",
  "about.activeOwnershipDesc": "دعم شركات المحفظة من خلال الدعم المالي والتخطيط الاستراتيجي ودعم تطوير الأعمال.",
  "about.innovationFocus": "التركيز على الابتكار",
  "about.innovationFocusDesc": "تركيز قوي على الأعمال القابلة للتوسع والمدفوعة بالابتكار في الطاقة والتكنولوجيا والحلول الصناعية.",
  "about.investmentSectors": "قطاعات الاستثمار",
  "about.learnMore": "اعرف المزيد عنا",
  "about.ceoQuote1": "في الأبل للاستثمار، رؤيتنا هي بناء مجموعة استثمارية متنوعة ومستقبلية تخلق قيمة طويلة الأمد مستدامة للمساهمين والشركاء والمجتمعات.",
  "about.ceoQuote2": "نركز على تحديد الفرص القابلة للتوسع وتمكين فرق القيادة ودعم الأعمال المدفوعة بالابتكار القادرة على التكيف مع الاقتصاد العالمي المتطور.",
  "about.ceoName": "محمد حمد العامري",
  "about.ceoTitle": "الرئيس التنفيذي",

  // Sectors
  "sector.energy": "الطاقة",
  "sector.technology": "التكنولوجيا",
  "sector.manufacturing": "التصنيع",
  "sector.electronics": "الإلكترونيات",
  "sector.industrial": "الحلول الصناعية",

  // Services
  "services.label": "خدماتنا",
  "services.title1": "كيف",
  "services.title2": "نعمل",
  "services.description": "نهجنا الاستراتيجي للاستثمار وخلق القيمة من خلال الدعم الشامل",
  "services.evaluation": "التقييم",
  "services.evaluationDesc": "نبحث باستمرار عن فرص استثمارية بنماذج أعمال قابلة للتوسع وفرق قيادية قوية.",
  "services.dueDiligence": "العناية الواجبة",
  "services.dueDiligenceDesc": "نجري تحليلاً مالياً وتقنياً وقانونياً شاملاً لضمان التوافق مع معاييرنا.",
  "services.activeManagement": "الإدارة الفعالة",
  "services.activeManagementDesc": "نلعب دوراً فعالاً على مستوى مجلس الإدارة لدعم فرق الإدارة استراتيجياً.",
  "services.valueCreation": "خلق القيمة",
  "services.valueCreationDesc": "نقدم التوجيه والدعم التشغيلي والوصول إلى شبكاتنا لدفع النمو.",
  "services.forCompanies": "للشركات",
  "services.corporateServices": "خدمات الشركات",
  "services.corporateDesc": "ندعم شركاتنا التابعة للعمل بشكل مستقل مع الاستفادة من القوة المالية وحوكمة المجموعة.",
  "services.corporate1": "الدعم المالي ورأس المال",
  "services.corporate2": "التخطيط الاستراتيجي والحوكمة",
  "services.corporate3": "دعم تطوير الأعمال",
  "services.corporate4": "الوصول إلى موارد وشبكات المجموعة",
  "services.forIndividuals": "للأفراد",
  "services.entrepreneurSupport": "دعم رواد الأعمال",
  "services.entrepreneurDesc": "تمكين رواد الأعمال والمبتكرين لتحويل الأفكار إلى أعمال مستدامة من خلال الدعم الشامل.",
  "services.entrepreneur1": "دعم المؤسسين في تحويل الأفكار إلى شركات",
  "services.entrepreneur2": "الاستثمار في الشركات الناشئة والنامية",
  "services.entrepreneur3": "توفير الهيكلة القانونية ورأس المال التأسيسي",
  "services.entrepreneur4": "الإرشاد والمشورة الاستراتيجية",
  "services.entrepreneur5": "التوجيه في التكنولوجيا وتطوير المنتجات",
  "services.learnMore": "اعرف المزيد",

  // Projects
  "projects.label": "المحفظة",
  "projects.title1": "المشاريع",
  "projects.title2": "الرائدة",
  "projects.description": "استثمارات استراتيجية عبر قطاعات الطاقة والتكنولوجيا والبناء تدفع الابتكار والنمو",
  "projects.energy.title": "الأبل للطاقة لحلول الطاقة",
  "projects.energy.desc": "التطوير والاستثمار في حزم البطاريات وأنظمة إدارة البطاريات (BMS) وحلول تخزين الطاقة لأدوات الطاقة والتنقل الكهربائي والتطبيقات الصناعية.",
  "projects.electronics.title": "الأبل للإلكترونيات",
  "projects.electronics.desc": "الاستثمار في تطوير المنتجات الإلكترونية والأنظمة المدمجة وأجهزة إنترنت الأشياء وحلول الاتصالات اللاسلكية للتحكم الذكي وتطبيقات المراقبة.",
  "projects.construction.title": "توب تيم للبناء",
  "projects.construction.desc": "تتخصص توب تيم للبناء في مشاريع البنية التحتية و البناء التجاري و التطوير العمراني ,مع التزام راسخ بالجودة و السلامة و التميز التشغيلي .",
  "projects.viewDetails": "عرض التفاصيل",
  "projects.investmentFocus": "تركيز الاستثمار",
  "projects.investmentFocusDesc": "تعمل شركات محفظتنا عبر قطاعات استراتيجية، مدعومة من خلال الاستثمار الرأسمالي والتوجيه الاستراتيجي والخبرة التشغيلية.",
  "projects.viewAll": "عرض جميع المشاريع",

  // Tags
  "tag.energy": "الطاقة",
  "tag.batterySystems": "أنظمة البطاريات",
  "tag.industrial": "صناعي",
  "tag.electronics": "إلكترونيات",
  "tag.iot": "إنترنت الأشياء",
  "tag.smartSystems": "الأنظمة الذكية",
  "tag.construction": "البناء",
  "tag.infrastructure": "البنية التحتية",
  "tag.development": "التطوير",

  // Values
  "values.label": "قيمنا",
  "values.title1": "المبادئ",
  "values.title2": "التوجيهية",
  "values.description": "قيمنا الأساسية توجه كل قرار استثماري وشراكة نقوم بها",
  "values.integrity": "النزاهة",
  "values.integrityDesc": "نلتزم بأعلى معايير الشفافية والمساءلة والسلوك الأخلاقي في جميع عملياتنا وشراكاتنا.",
  "values.longTerm": "الرؤية طويلة المدى",
  "values.longTermDesc": "نسعى لاستثمارات مستدامة تستند الى قرارات مدروسة و منضبطة ,بما يسهم في  خلق قيمة طويلة الأمد.",
  "values.excellence": "التميز",
  "values.excellenceDesc": "نسعى الى تحقيق التميز التشغيلي والانضباط الاستراتيجي والتحسين المستمر في جميع اعمالنا وانشطتنا.",
  "values.innovation": "الابتكار",
  "values.innovationDesc": "ندعم الأعمال المدفوعة بالابتكار والتقنيات الناشئة التي تساهم في النمو الاقتصادي المستقبلي والتحول الصناعي.",
  "values.collaboration": "التعاون",
  "values.collaborationDesc": "نؤمن ببناء شراكات قوية مع المؤسسين وأصحاب المصلحة وفرق الإدارة لتحقيق النجاح المشترك.",
  "values.quote": "قيمنا هي أساس نجاحنا وحجر الزاوية في علاقاتنا مع الشركاء والمستثمرين وشركات المحفظة.",

  // CTA
  "cta.label": "تواصل معنا",
  "cta.title1": "لنبني",
  "cta.title2": "المستقبل معاً",
  "cta.description": "سواء كنت تبحث عن استثمار أو فرص شراكة أو توجيه استراتيجي، نحن هنا لمساعدتك في تحقيق أهدافك.",
  "cta.contactUs": "اتصل بنا",
  "cta.callNow": "اتصل الآن",
  "cta.phone": "الهاتف",
  "cta.email": "البريد الإلكتروني",
  "cta.website": "الموقع الإلكتروني",
  "cta.location": "الموقع",

  // Footer
  "footer.description": "بناء مجموعة استثمارية قوية ومتنوعة تخلق قيمة طويلة الأمد عبر قطاعات الطاقة والتكنولوجيا والصناعة.",
  "footer.quickLinks": "روابط سريعة",
  "footer.portfolio": "المحفظة",
  "footer.contact": "اتصل بنا",
  "footer.aboutUs": "من نحن",
  "footer.batteryEnergy": "البطاريات وتخزين الطاقة",
  "footer.iotSmart": "إنترنت الأشياء والأنظمة الذكية",
  "footer.infrastructure": "تطوير البنية التحتية",
  "footer.copyright": "© 2026 الأبل للاستثمار. جميع الحقوق محفوظة.",
  "footer.privacy": "سياسة الخصوصية",
  "footer.terms": "شروط الخدمة",

  // Language
  "language": "اللغة",
  "language.en": "English",
  "language.ar": "العربية",

  // About Page
  "aboutPage.breadcrumb.home": "الرئيسية",
  "aboutPage.breadcrumb.about": "من نحن",
  "aboutPage.hero.label": "من نحن",
  "aboutPage.hero.title1": "عن",
  "aboutPage.hero.title2": "الأبل",
  "aboutPage.hero.description": "الابل للاْستثمار تأسست للاستثمار والاستحواذ وإدارة محفظة متنوعة من الأعمال عبر القطاعات الاستراتيجية.",
  "aboutPage.story.title1": "قصتنا",
  "aboutPage.story.title2": "",
  "aboutPage.story.p1": "تعمل الأبل للاستثمار على الاستحواذ على الشركات ذات إمكانات النمو العالية وتطويرها ودعمها عبر الأسواق الإقليمية والدولية.",
  "aboutPage.story.p2": "تتخذ الابل للاستثمار من الإمارات العربية المتحدة مقراً لها، وتوفر الدعم الرأسمالي والإشراف على الحوكمة والتخطيط الاستراتيجي والتوجيه التشغيلي لشركات محفظتها.",
  "aboutPage.story.p3": "بفلسفة استثمارية طويلة الأمد ونهج يركز على الابتكار، تسعى الأبل إلى خلق قيمة مستدامة من خلال الاستثمارات المنضبطة ونماذج الشراكة الفعالة.",
  // "aboutPage.story.p4": "لا تشارك الابل للاستثمار في العمليات المباشرة؛ بل تدعم شركات محفظتها من خلال الدعم المالي والتخطيط الاستراتيجي وحوكمة الشركات ودعم تطوير الأعمال.",
  // "aboutPage.story.p5": "تشمل اهتمامات الأبل الاستثمارية الطاقة والتكنولوجيا والتصنيع والإلكترونيات والحلول الصناعية، مع تركيز قوي على الأعمال القابلة للتوسع والمدفوعة بالابتكار في الأسواق الإقليمية والدولية.",
  "aboutPage.established": "تأسست",
  "aboutPage.process.label": "آلية العمل",
  "aboutPage.process.title1": "كيف",
  "aboutPage.process.title2": "نعمل",
  "aboutPage.process.step1.title": "التقييم",
  "aboutPage.process.step1.desc": "نحدد ونقيم باستمرار فرص الاستثمار عالية الإمكانات ذات نماذج الأعمال القابلة للتوسع والقوة التشغيلية وفرق القيادة ذات الخبرة.",
  "aboutPage.process.step2.title": "العناية الواجبة",
  "aboutPage.process.step2.desc": "نجري تقييمات مالية وتشغيلية وتقنية وقانونية شاملة لضمان التوافق مع استراتيجيتنا الاستثمارية وأهدافنا طويلة الأمد.",
  "aboutPage.process.step3.title": "الإدارة الفعالة",
  "aboutPage.process.step3.desc": "نعمل عن كثب مع فرق الإدارة من خلال توفير الإشراف الاستراتيجي ودعم الحوكمة والتوجيه التشغيلي لدفع النمو المستدام.",
  "aboutPage.process.step4.title": "خلق القيمة",
  "aboutPage.process.step4.desc": "ندعم شركات المحفظة من خلال تخصيص رأس المال والتخطيط الاستراتيجي والتحسين التشغيلي والوصول إلى شبكة أعمالنا ومواردنا.",
  "aboutPage.values.label": "قيمنا",
  "aboutPage.values.title1": "المبادئ",
  "aboutPage.values.title2": "التوجيهية",
  "aboutPage.values.integrity": "النزاهة",
  "aboutPage.values.integrityDesc": "نلتزم بأعلى معايير الصدق والمساءلة والشفافية في جميع تعاملاتنا.",
  "aboutPage.values.longTerm": "الرؤية طويلة المدى",
  "aboutPage.values.longTermDesc": "نتخذ قرارات الاستثمار بتوجيه من رؤية طويلة المدى، محددين الفرص المستدامة.",
  "aboutPage.values.excellence": "التميز",
  "aboutPage.values.excellenceDesc": "نسعى للتميز في جميع جوانب استثماراتنا وحوكمتنا.",
  "aboutPage.values.innovation": "الابتكار",
  "aboutPage.values.innovationDesc": "ندعم الأفكار والتقنيات المبتكرة، مساعدين شركات المحفظة على التوسع والتكيف.",
  "aboutPage.values.collaboration": "التعاون",
  "aboutPage.values.collaborationDesc": " نؤمن ببناء شراكات قوية مع المؤسسين وأصحاب المصلحة وفرق الادارة لتحقيق النجاح المشترك.",

  // Services Page
  "servicesPage.breadcrumb.home": "الرئيسية",
  "servicesPage.breadcrumb.services": "الخدمات",
  "servicesPage.hero.label": "ما نقدمه",
  "servicesPage.hero.title1": "خدماتنا",
  "servicesPage.hero.title2": "",
  "servicesPage.hero.description": "خدمات استثمارية واستشارية استراتيجية ودعم أعمال شاملة مصممة لتسريع النمو المستدام للشركات ورواد الأعمال.",
  "servicesPage.corporate.label": "للشركات",
  "servicesPage.corporate.title1": "خدمات",
  "servicesPage.corporate.title2": "الشركات",
  "servicesPage.corporate.description": "ندعم شركات المحفظة والشركاء من خلال التوجيه الاستراتيجي وأطر الحوكمة والدعم التشغيلي ومبادرات تطوير الأعمال طويلة الأمد.",
  "servicesPage.corporate.item1.title": "الدعم المالي",
  "servicesPage.corporate.item1.desc": "دعم رأس المال وحلول التمويل المنظمة لمبادرات النمو الاستراتيجي.",
  "servicesPage.corporate.item2.title": "التخطيط الاستراتيجي",
  "servicesPage.corporate.item2.desc": "التخطيط التجاري طويل الأمد واستراتيجيات تحديد المواقع في السوق.",
  "servicesPage.corporate.item3.title": "حوكمة الشركات",
  "servicesPage.corporate.item3.desc": "الإشراف على مستوى مجلس الإدارة وأطر الحوكمة وتطوير الهيكل التنظيمي.",
  "servicesPage.corporate.item4.title": "تطوير الأعمال",
  "servicesPage.corporate.item4.desc": "استراتيجيات التوسع في السوق وفرص الشراكة ودعم النمو التجاري.",
  "servicesPage.corporate.item5.title": "الوصول للشبكات",
  "servicesPage.corporate.item5.desc": "توفير الوصول إلى شبكات الاعمال و المستثمريين و الشركاء الاستراجيين على المستويين الاقليمي و الدولي.",
  "servicesPage.individual.label": "للأفراد",
  "servicesPage.individual.title1": "دعم",
  "servicesPage.individual.title2": "رواد الأعمال",
  "servicesPage.individual.description": "نمكّن رواد الأعمال والمؤسسين المدفوعين بالابتكار من تحويل الأفكار القابلة للتوسع إلى أعمال مستدامة من خلال الاستثمار والإرشاد والدعم الاستراتيجي.",
  "servicesPage.individual.item1.title": "من الفكرة للشركة",
  "servicesPage.individual.item1.desc": "دعم المؤسسين في تحويل الافكار المبتكرة الى مشاريع و شركات قابلة للنمو و التوسع.",
  "servicesPage.individual.item2.title": "الاستثمار في الشركات الناشئة",
  "servicesPage.individual.item2.desc": "الاستثمار في المشاريع المبكرة والمراحل النامية ذات إمكانات السوق القوية.",
  "servicesPage.individual.item3.title": "الهيكلة القانونية",
  "servicesPage.individual.item3.desc": "دعم الإعداد القانوني وهيكلة الأعمال والأطر التشغيلية التأسيسية.",
  "servicesPage.individual.item4.title": "الإرشاد",
  "servicesPage.individual.item4.desc": "تقديم التوجيه الاستراتيجي والإرشاد التشغيلي والاستشارات للنمو.",
  "servicesPage.individual.item5.title": "التوجيه التقني",
  "servicesPage.individual.item5.desc": "دعم تطوير المنتجات واستراتيجية التكنولوجيا وتنفيذ الابتكار.",
  "servicesPage.cta.title1": "مستعد",
  "servicesPage.cta.title2": "للشراكة",
  "servicesPage.cta.title3": "معنا؟",
  "servicesPage.cta.description": "سواء كنت شركة تبحث عن استثمار أو رائد أعمال لديه رؤية، نحن هنا للمساعدة.",
  "servicesPage.cta.button": "تواصل معنا",

  // Portfolio Page
  "portfolioPage.breadcrumb.home": "الرئيسية",
  "portfolioPage.breadcrumb.portfolio": "المحفظة",
  "portfolioPage.hero.label": "استثماراتنا",
  "portfolioPage.hero.title1": "شركات",
  "portfolioPage.hero.title2": "المحفظة",
  "portfolioPage.hero.description": "محفظة متنوعة من المشاريع الاستراتيجية تركز على النمو المستدام والابتكار الصناعي وخلق القيمة طويلة الأمد.",
  "portfolioPage.energy.title": "الأبل لحلول الطاقة",
  "portfolioPage.energy.desc": "التطوير والاستثمار في حزم البطاريات وأنظمة إدارة البطاريات (BMS) وحلول تخزين الطاقة لأدوات الطاقة والتنقل الكهربائي والتطبيقات الصناعية.",
  "portfolioPage.energy.fullDesc": "تركز الأبل لحلول الطاقة على تقنيات البطاريات المتقدمة وأنظمة تخزين الطاقة والبنية التحتية للطاقة المستدامة لدعم التحول في قطاع الطاقة عالمياً.",
  "portfolioPage.electronics.title": "الأبل للإلكترونيات",
  "portfolioPage.electronics.desc": "الاستثمار في تطوير المنتجات الإلكترونية والأنظمة المدمجة وأجهزة إنترنت الأشياء وحلول الاتصالات اللاسلكية للتحكم الذكي وتطبيقات المراقبة.",
  "portfolioPage.electronics.fullDesc": "تطور الأبل للإلكترونيات أنظمة إلكترونية متقدمة وتقنيات إنترنت الأشياء وحلول اتصالات ذكية تدعم الأتمتة والتحول الرقمي.",
  "portfolioPage.construction.title": "توب تيم للبناء",
  "portfolioPage.construction.desc": "توب تيم للبناء هي شركة محفظة استراتيجية متخصصة في البناء وتطوير البنية التحتية ومشاريع البناء الجاهزة.",
  "portfolioPage.construction.fullDesc": "تتخصص توب تيم للبناء في البنية التحتية والبناء التجاري ومشاريع التطوير الجاهزة مع التزام قوي بالجودة والسلامة والتميز التشغيلي.",
  "portfolioPage.keyFocus": "مجالات التركيز الرئيسية:",
  "portfolioPage.sectors.label": "تركيز الاستثمار",
  "portfolioPage.sectors.title1": "القطاعات",
  "portfolioPage.sectors.title2": "الاستراتيجية",
  "portfolioPage.sectors.energy": "الطاقة",
  "portfolioPage.sectors.energyDesc": "بنية تحتية متقدمة للطاقة وحلول الطاقة المستدامة.",
  "portfolioPage.sectors.technology": "التكنولوجيا",
  "portfolioPage.sectors.technologyDesc": "أنظمة رقمية مدفوعة بالابتكار وتقنيات ذكية.",
  "portfolioPage.sectors.manufacturing": "التصنيع",
  "portfolioPage.sectors.manufacturingDesc": "إنتاج صناعي وقدرات تصنيع متقدمة.",
  "portfolioPage.sectors.electronics": "الإلكترونيات",
  "portfolioPage.sectors.electronicsDesc": "أنظمة إلكترونية ذكية وتقنيات الاتصال.",
  "portfolioPage.sectors.industrial": "الصناعة",
  "portfolioPage.sectors.industrialDesc": "بنية تحتية صناعية وحلول تركز على الأتمتة.",
  "portfolioPage.sectors.agricultural": "الزراعة",
  "portfolioPage.sectors.agriculturalDesc": "الاستثمار في المشروعات الزراعية وحلول الزراعة المستدامة.",
  "portfolioPage.sectors.tourism": "السياحة",
  "portfolioPage.sectors.tourismDesc": "الاستثمار في المشروعات السياحية وإدارة الضيافة.",
  "portfolioPage.sectors.healthcare": "الرعاية الصحية",
  "portfolioPage.sectors.healthcareDesc": "الاستثمار في خدمات الرعاية الصحية والتطوير الطبي.",
  "portfolioPage.sectors.commercial": "التجاري",
  "portfolioPage.sectors.commercialDesc": "الاستثمار في المشروعات التجارية وإدارة الأعمال.",
  "portfolioPage.sectors.oilgas": "النفط والغاز",
  "portfolioPage.sectors.oilgasDesc": "الاستثمار في مشروعات النفط والغاز الطبيعي.",
  "portfolioPage.sectors.educational": "التعليم",
  "portfolioPage.sectors.educationalDesc": "الاستثمار في المشروعات التعليمية ومؤسسات التعلم.",
  "portfolioPage.cta.title1": "مهتم",
  "portfolioPage.cta.title2": "بالشراكة",
  "portfolioPage.cta.description": "نبحث دائماً عن شركات مبتكرة ورواد أعمال للشراكة معهم.",
  "portfolioPage.cta.button": "اتصل بنا",
  "portfolioPage.tags.energy": "تخزين الطاقة",
  "portfolioPage.tags.batterySystems": "تقنيات البطاريات",
  "portfolioPage.tags.industrial": "حلول الطاقة الصناعية",
  "portfolioPage.tags.industrial.solutions": "الحلول الصناعية",
  "portfolioPage.tags.electricMobility": "التنقل الكهربائي",
  "portfolioPage.tags.electronics": "الإلكترونيات",
  "portfolioPage.tags.iot": "إنترنت الأشياء",
  "portfolioPage.tags.smartSystems": "الأنظمة الذكية",
  "portfolioPage.tags.rfCommunication": "اتصالات RF",
  "portfolioPage.tags.construction": "البناء",
  "portfolioPage.tags.infrastructure": "البنية التحتية",
  "portfolioPage.tags.development": "التطوير",
  "portfolioPage.tags.turnkeyProjects": "المشاريع الجاهزة",
  "portfolioPage.rd.title": "أبحاث وتطوير الأبل",
  "portfolioPage.rd.desc": "البحث والتطوير",
  "portfolioPage.rd.fullDesc": "تقود الأبل للبحث والتطوير الابتكار من خلال البحث المتقدم وتطوير التكنولوجيا عبر قطاعات الطاقة والروبوتات والأتمتة والأنظمة الصناعية.",
  "portfolioPage.robotics.title": "روبوتيكس الأبل",
  "portfolioPage.robotics.desc": "الروبوتات والأتمتة",
  "portfolioPage.robotics.fullDesc": "تطور الأبل للروبوتات أنظمة روبوتية ذكية وتقنيات أتمتة مصممة لتحسين الإنتاجية الصناعية وقدرات التصنيع الذكي.",
  "portfolioPage.device.title": "جهاز الأبل",
  "portfolioPage.device.desc": "الأجهزة الذكية والإلكترونيات",
  "portfolioPage.device.fullDesc": "تصمم وتصنع الأبل للأجهزة أجهزة إلكترونية متقدمة وأنظمة تحكم ذكية للتطبيقات الصناعية والتجارية والاستهلاكية.",
  "portfolioPage.tags.research": "بحث",
  "portfolioPage.tags.innovation": "ابتكار",
  "portfolioPage.tags.robotics": "روبوتيكس",
  "portfolioPage.tags.automation": "أتمتة",
  "portfolioPage.tags.ai": "ذكاء اصطناعي",
  "portfolioPage.tags.devices": "الأجهزة الذكية",
  "portfolioPage.tags.embedded.systems": "الأنظمة المدمجة",
  "portfolioPage.tech.title": "أبل تك",
  "portfolioPage.tech.desc": "حلول تقنية متكاملة تدعم التحول الرقمي.",
  "portfolioPage.tech.fullDesc": "تطور أبل تك منصات رقمية متكاملة وحلول برمجية للمؤسسات وبنية تحتية تقنية تسرع التحول الرقمي للشركات عبر الإمارات والأسواق الإقليمية.",
  "portfolioPage.tags.digital": "رقمي",
  "portfolioPage.tags.software": "برمجيات",
  "portfolioPage.tags.technology.development": "تطوير التكنولوجيا",

  // Contact Page
  "contactPage.breadcrumb.home": "الرئيسية",
  "contactPage.breadcrumb.contact": "اتصل بنا",
  "contactPage.hero.label": "تواصل معنا",
  "contactPage.hero.title1": "اتصل",
  "contactPage.hero.title2": "بنا",
  "contactPage.hero.description": "مستعد لمناقشة فرص الاستثمار أو الشراكة؟ يسعدنا سماعك.",
  "contactPage.form.title": "أرسل لنا رسالة",
  "contactPage.form.success": "شكراً لك! تم إرسال رسالتك بنجاح.",
  "contactPage.form.name": "الاسم الكامل",
  "contactPage.form.namePlaceholder": "اسمك",
  "contactPage.form.email": "البريد الإلكتروني",
  "contactPage.form.emailPlaceholder": "بريدك@email.com",
  "contactPage.form.company": "الشركة",
  "contactPage.form.companyPlaceholder": "شركتك",
  "contactPage.form.subject": "الموضوع",
  "contactPage.form.subjectPlaceholder": "اختر موضوعاً",
  "contactPage.form.subjectInvestment": "استفسار استثماري",
  "contactPage.form.subjectPartnership": "فرصة شراكة",
  "contactPage.form.subjectStartup": "دعم الشركات الناشئة",
  "contactPage.form.subjectGeneral": "استفسار عام",
  "contactPage.form.message": "الرسالة",
  "contactPage.form.messagePlaceholder": "أخبرنا عن استفسارك...",
  "contactPage.form.submit": "إرسال الرسالة",
  "contactPage.form.sending": "جاري الإرسال...",
  "contactPage.info.title": "معلومات الاتصال",
  "contactPage.info.description": "سواء كنت تبحث عن استثمار أو فرص شراكة أو توجيه استراتيجي، نحن هنا لمساعدتك في تحقيق أهدافك.",
  "contactPage.info.phone": "الهاتف",
  "contactPage.info.email": "البريد الإلكتروني",
  "contactPage.info.website": "الموقع الإلكتروني",
  "contactPage.info.location": "الموقع",
  "contactPage.info.locationValue": "دبي، الإمارات العربية المتحدة",
  "contactPage.info.locationDesc": "مكتب رقم 501، الطابق الخامس، مبنى ناسكو، صلاح الدين، دبي، الإمارات",
  // "contactPage.info.locationValue": "الإمارات العربية المتحدة",
  // "contactPage.info.locationDesc": "نخدم الأسواق الإقليمية والدولية",

  // Invest Page
  "investPage.hero.label": "فرص الاستثمار",
  "investPage.hero.title1": "ابدأ",
  "investPage.hero.title2": "الاستثمار",
  "investPage.hero.description": "كن شريكاً مع الأبل واستثمر في القطاعات التي تشكل اقتصاد الغد.",
  "investPage.form.title": "استفسار استثماري",
  "investPage.form.name": "الاسم الكامل",
  "investPage.form.namePlaceholder": "اسمك",
  "investPage.form.email": "البريد الإلكتروني",
  "investPage.form.emailPlaceholder": "بريدك@email.com",
  "investPage.form.company": "الشركة",
  "investPage.form.companyPlaceholder": "شركتك",
  "investPage.form.message": "الرسالة",
  "investPage.form.messagePlaceholder": "أخبرنا عن اهتمامك بهذا الاستثمار...",
  "investPage.form.submit": "إرسال الاستفسار",
  "investPage.form.sending": "جاري الإرسال...",
  "investPage.form.success": "شكراً لك! تم إرسال استفسارك بنجاح.",
  "investPage.form.close": "إغلاق",
  "investPage.investments.agricultural": "الاستثمار في المشروعات الزراعية وتأسيسها وادارتها",
  "investPage.investments.tourist": "الاستثمار في المشروعات السياحية و تأسيسها و إدارتها",
  "investPage.investments.healthcare": "الاستثمار في مشروعات الخدمات الصحية والصناعات الدواىْية  و تأسيسها و ادارتها",
  "investPage.investments.commercial": "الاستثمار في المشروعات التجارية وتأسيسها وادارتها",
  "investPage.investments.technological": "الاستثمار في المشروعات التكنولوجية وتأسيسها وادارتها",
  "investPage.investments.energy": "الاستثمار في مشروعات الطاقة وتأسيسها و إدارتها",
  "investPage.investments.oil": "الاستثمار في مشروعات النفط والغاز الطبيعي",
  "investPage.investments.industrial": "الاستثمار في المشروعات الصناعية وتأسيسها وادارتها",
  "investPage.investments.educational": "الاستثمار في المشروعات التعليمية وتأسيسها وإدارتها",

  "sector.agricultural": "الزراعة",
  "sector.tourism": "السياحة",
  "sector.healthcare": "الرعاية الصحية",
  "sector.commercial": "التجاري",
  "sector.oilgas": "النفط والغاز",
  "sector.educational": "التعليم",

  "aboutPage.highlights.uaeBased": "الابل للاستثمار مقرها الإمارات",
"aboutPage.highlights.uaeBasedDesc": "مقرها دبي، الإمارات العربية المتحدة، مع تركيز على فرص الاستثمار الإقليمية والدولية.",
"aboutPage.highlights.multiSector": "محفظة متعددة القطاعات",
"aboutPage.highlights.multiSectorDesc": "استثمارات متنوعة في قطاعات الطاقة والتكنولوجيا والإلكترونيات والبناء والحلول الصناعية.",
"aboutPage.highlights.innovation": "استثمارات تركز على الابتكار",
"aboutPage.highlights.innovationDesc": "دعم الأعمال القابلة للتوسع والمدفوعة بالابتكار التي تشكل مستقبل الصناعة والتكنولوجيا.",
"aboutPage.highlights.longTerm": "نمو استراتيجي طويل الأمد",
"aboutPage.highlights.longTermDesc": "فلسفة استثمارية منضبطة تركز على خلق قيمة مستدامة على المدى البعيد.",
"aboutPage.highlights.regional": "استراتيجية التوسع الإقليمي",
"aboutPage.highlights.regionalDesc": "توسع نشط في حضور المحفظة عبر أسواق دول الخليج والمنطقة.",
"aboutPage.whyPartner.vision": "رؤية استثمارية طويلة الأمد",
"aboutPage.whyPartner.visionDesc": "نستثمر بمنظور طويل الأمد، ندعم الأعمال في جميع مراحل النمو.",
"aboutPage.whyPartner.support": "دعم تشغيلي استراتيجي",
"aboutPage.whyPartner.supportDesc": "نقدم توجيهاً استراتيجياً عملياً وحوكمة ودعماً تشغيلياً لشركات المحفظة.",
"aboutPage.whyPartner.expertise": "خبرة صناعية",
"aboutPage.whyPartner.expertiseDesc": "معرفة عميقة بقطاعات الطاقة والتكنولوجيا والبناء والصناعة في الإمارات والمنطقة.",
"aboutPage.whyPartner.innovation": "نهج يركز على الابتكار",
"aboutPage.whyPartner.innovationDesc": "نسعى بنشاط لدعم الأعمال المدفوعة بالابتكار ذات الإمكانات القابلة للتوسع.",
"aboutPage.whyPartner.market": "الوصول إلى السوق الإقليمية",
"aboutPage.whyPartner.marketDesc": "الاستفادة من الشبكات الإقليمية القوية وعلاقات السوق لتسريع نمو الأعمال.",

"projects.store.title": "أبل ستور",
"projects.store.desc": "منصة تجارة إلكترونية فاخرة تقدم منتجات مميزة ومجموعات حصرية، تجمع بين تجربة تجزئة راقية والتجارة الرقمية المتطورة.",
"projects.tech.title": "أبل تك",
"projects.tech.desc": "تطوير حلول تقنية متكاملة وخدمات رقمية مبتكرة تدعم التحول الرقمي وتعزز الكفاءة التشغيلية عبر مختلف القطاعات.",
"projects.healthcare.title": "أبل للرعاية الصحية",
"projects.healthcare.desc": "الاستثمار في مشاريع الرعاية الصحية والصيدلانية التي تعزز نتائج المرضى والابتكار الطبي وإمكانية الوصول إلى الرعاية الصحية في المنطقة.",
"projects.racing.title": "أبل ريسينج",
"projects.racing.desc": "السعي نحو التميز في رياضة السيارات من خلال الاستثمار الاستراتيجي في فرق السباقات وهندسة الأداء وثقافة السرعة.",
"projects.device.title": "جهاز الأبل",
"projects.device.desc": "تصميم وتصنيع أجهزة إلكترونية مبتكرة وأنظمة تحكم ذكية للتطبيقات الصناعية والتجارية والاستهلاكية.",
"projects.rnd.title": "أبحاث وتطوير الأبل",
"projects.rnd.desc": "ريادة البحث والتطوير في التقنيات الناشئة، ودفع الابتكار عبر قطاعات الطاقة والإلكترونيات والصناعة في الإمارات وخارجها.",
"projects.websiteLabel": "الموقع",
"tag.luxury": "تجارة فاخرة",
"tag.ecommerce": "تجارة إلكترونية",
"tag.retail": "تجزئة",
"tag.technology": "تقنية",
"tag.digital": "تحول رقمي",
"tag.software": "برمجيات",
"tag.healthcare": "رعاية صحية",
"tag.pharmaceuticals": "صيدلة",
"tag.wellness": "صحة",
"tag.motorsport": "سباقات",
"tag.performance": "أداء",
"tag.racing": "رياضة السيارات",
"tag.devices": "أجهزة",
"tag.smartTech": "تقنية ذكية",
"tag.research": "بحث",
"tag.innovation": "ابتكار",
"tag.technologyDev": "تكنولوجيا",

"portfolioPage.store.title": "أبل ستور",
"portfolioPage.store.desc": "تجارة فاخرة",
"portfolioPage.store.fullDesc": "منصة تجارة إلكترونية فاخرة تقدم منتجات مميزة ومجموعات حصرية، تجمع بين تجربة تجزئة راقية والتجارة الرقمية المتطورة.",
"portfolioPage.healthcare.title": "أبل للرعاية الصحية",
"portfolioPage.healthcare.desc": "الرعاية الصحية والصيدلة",
"portfolioPage.healthcare.fullDesc": "الاستثمار في مشاريع الرعاية الصحية والصيدلانية التي تعزز نتائج المرضى والابتكار الطبي وإمكانية الوصول إلى الرعاية الصحية في المنطقة.",
"portfolioPage.racing.title": "أبل ريسينج",
"portfolioPage.racing.desc": "رياضة السيارات والأداء",
"portfolioPage.racing.fullDesc": "السعي نحو التميز في رياضة السيارات من خلال الاستثمار الاستراتيجي في فرق السباقات وهندسة الأداء وثقافة السرعة.",
"portfolioPage.visitWebsite": "زيارة الموقع",
"portfolioPage.metrics.companies": "شركات المحفظة",
"portfolioPage.metrics.sectors": "قطاعات الاستثمار",
"portfolioPage.metrics.headquartered": "المقر الرئيسي",
"portfolioPage.metrics.uaeValue": "الإمارات",
"portfolioPage.metrics.companyProfile": "ملف الشركة",
"portfolioPage.metrics.company": "ملف",
"portfolioPage.metrics.profile": "الشركة"
};

export default common;


